import { autoRegisterFeature } from '@store/features/factory';

import { payments } from './store/feature';

// Auto-register the feature
autoRegisterFeature(payments);

// Export components
export type {
  RequestPaymentButtonProps,
  PaymentsColdStartProps,
  PatientPaymentMethodCardProps,
  PatientPaymentMethodListProps,
  AddPatientPaymentMethodModalProps,
  PatientPaymentMethodsBlockProps,
  // Patient Invoices types
  PatientInvoiceCardProps,
  PatientInvoicesListProps,
  PatientInvoicesBlockProps,
} from './components';
export {
  PaymentsColdStart,
  PaymentsPage,
  RequestPaymentButton,
  StripeConnectButton,
  StripeConnectStatus,
  StripeInvoicesTable,
  StripeInvoicesTableCard,
  // Patient Payment Methods
  PatientPaymentMethodCard,
  PatientPaymentMethodList,
  AddPatientPaymentMethodModal,
  PatientPaymentMethodsBlock,
  // Patient Invoices
  PatientInvoiceCard,
  PatientInvoicesList,
  PatientInvoicesBlock,
} from './components';

// Export modal components (for lazy loading in modal registry)
export { default as PaymentRequestModal } from './components/PaymentRequestModal';
export { default as StripeConnectInfoModal } from './components/StripeConnectInfoModal';

// Export hooks
export { useRequestPayment } from './hooks/useRequestPayment';

// Export store functionality
export {
  payments,
  paymentsApi,
  // Stripe Connect hooks
  useCreateStripeConnectMutation,
  useCreateStripeDashboardLinkMutation,
  useGetStripeConnectStatusQuery,
  useGetStripeInvoicesQuery,
  useLazyGetStripeInvoicesQuery,
  useSendPaymentRequest,
  useSendPaymentRequestMutation,
  useStripeConnect,
  useStripeDashboard,
  // Patient Payment Methods hooks
  useGetPatientPaymentMethodsQuery,
  useGetPatientPaymentMethodStatusQuery,
  useSetupPatientPaymentMethodMutation,
  useConfirmPatientPaymentMethodMutation,
  useDeletePatientPaymentMethodMutation,
  useSetDefaultPatientPaymentMethodMutation,
  usePatientPaymentMethods,
  // Patient Invoices hooks
  useGetPatientInvoicesQuery,
  usePatientInvoices,
} from './store';

// Re-export types from store
export type { InvoiceStatusFilter } from './store';

// Export types (renamed to avoid conflicts)
export type {
  PaymentRequest,
  PaymentRequestResponse,
  StripeConnectRequest,
  StripeConnectResponse,
  StripeConnectStatus as StripeConnectStatusType,
  StripeDashboardLinkRequest,
  StripeDashboardLinkResponse,
  StripeInvoice,
  StripeInvoicesResponse,
  // Patient Payment Methods types
  PatientPaymentMethod,
  PatientPaymentMethodsListResponse,
  PatientPaymentMethodStatus,
  PatientPaymentSetupResponse,
} from './types';
